


















import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import BottomTabbar from './components/BottomTabbar.vue';
import Rule from './components/Rule.vue';
import { getBaseInfo } from './api';
import { Popup, Swipe, SwipeItem } from 'vant';
import Music from './components/Music.vue';

Vue.use(Popup)
  .use(Swipe)
  .use(SwipeItem);
const baseUrl = 'fmxy';

@Component({
  components: {
    BottomTabbar,
    Rule,
    Music,
  },
})
export default class ViewHolder extends Vue {
  tabs: any[] = [
    {
      title: '活动主页',
      path: `/${baseUrl}/home`,
      id: 1,
    },
    {
      title: '活动简介',
      path: `/${baseUrl}/rule`,
      id: 2,
    },
  ];

  activeTab = 0;
  baseInfo: any = {};
  show: boolean = true;
  showTab: boolean = false;
  home: boolean = false;
  selectTabNum: number = 0;
  successStatus = false;

  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/2023-10-31/1698748749784_0.26080911138071605logo.png';
    // App分享
    this.$appShareInfo({
      title: '点赞投票|2021-2022年度“富民兴渝贡献奖”评选',
      url: 'https://activity.cqcb.com/shangyou_activity/2023h2/fmxy/home',
      subtitle: `选出您心目中的“城市榜样”`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '点赞投票|2021-2022年度“富民兴渝贡献奖”评选',
        subtitle: `选出您心目中的“城市榜样”`,
        image: cover,
      });
    }
  }

  async created() {
    const index = this.tabs.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
    // setTimeout(() => {
    //   this.showTab = true;
    // }, 5900);
    // setTimeout(() => {
    //   this.home = true;
    // }, 5000);
  }

  showPopup() {
    this.show = true;
  }
  toggleModal() {
    this.show = false;
  }
  goHome() {
    setTimeout(() => {
      this.showTab = true;
    }, 900);
    this.home = true;
  }
  selectNum(data: number) {
    this.selectTabNum = data;
  }
  success() {
    this.successStatus = true;
  }
}
